import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const ContactMediumItem = (props) => {

    let classes = "d-flex flex-row align-items-start justify-content-center"

    if(props.className) classes = `${classes} ${props.className}`

    return (
        <div className={classes}>
            <FontAwesomeIcon color="#83a6ed" icon={props.icon} className="mr-2" color={props.color}/>
            <small>{props.info}</small>
        </div>
    )

}

export default ContactMediumItem